export const INIT = "login/init";
export const CHANGE_FORM = "login/CHANGE_FORM";
export const SET_ERRORS = "login/SET_ERRORS";

// Action
export const init = () => ({
  type: INIT
});

export const changeForm = (key, value) => ({
  type: CHANGE_FORM,
  key,
  value
});

export const setErrors = errors => ({
  type: SET_ERRORS,
  errors
});

// Reducer
const initialState = {
  errors: [],
  loginId: "",
  customerId: "",
  password: ""
};

const login = (state = initialState, action) => {
  switch (action.type) {
    case INIT:
      return initialState;
    case SET_ERRORS:
      return { ...state, errors: action.errors };
    case CHANGE_FORM: {
      const { key, value } = action;
      return { ...state, [key]: value };
    }
    default:
      return state;
  }
};

export default login;



// WEBPACK FOOTER //
// ./src/redux/modules/login.js